const nav = document.querySelector('[is="nav-spy"]')
const navTogglesSelector = `.${nav.dataset.highlights}`
const navActiveClass = `${nav.dataset.highlights}-active`
const navActiveSelector = `.${navActiveClass}`

const setLotacionHrefHash = anchorId => {
  const currentWindowPosition = window.scrollY
  location.hash = anchorId
  window.scrollTo(0, currentWindowPosition)
}

const horizontalScrollItem = item => {
  const offsetLeft = item.offsetLeft
  const parentWidth = item.offsetParent.getBoundingClientRect().width
  const width = item.getBoundingClientRect().width

  item.offsetParent.scrollTo(offsetLeft - ((parentWidth - width) / 2), 0)
}

const deactivateActiveItems = _ => {
  const activeElements = nav.querySelectorAll(navActiveSelector)

  activeElements.forEach(element => element.classList.remove(navActiveClass))
}

const activateItem = item => {
  item.classList.add(navActiveClass)
  horizontalScrollItem(item)
}

const activateLastOverlappedItem = _ => {
  deactivateActiveItems()

  const allOverlapMarks = nav.querySelectorAll('[data-overlaps]')

  if (allOverlapMarks.length) {
    const lastOverlapMark = Array.from(allOverlapMarks).reverse()[0]
    activateItem(lastOverlapMark)
  }
}

const onIntersecting = current => {
  current.itemToActivate.dataset.overlaps = true
  activateLastOverlappedItem()
}

const afterIntersecting = current => {
  delete current.itemToActivate.dataset.overlaps
  activateLastOverlappedItem()
}

const onLinkClickListener = (event, current) => {
  event.preventDefault()
  current.itemToActivate.dataset.clicked = true
  scrollToTarget(current)
}

const scrollToTarget = current => {
  const mainNav = document.querySelector('.rnk-MainSiteNav')
  const mainNavIsFixed = window.getComputedStyle(mainNav, null).getPropertyValue('position') === 'fixed'
  const mainNavOffset = mainNavIsFixed ? mainNav.getBoundingClientRect().height : 0
  const thisNavOffset = nav.getBoundingClientRect().height
  const currentAnchorPosition = current.target.offsetTop
  const scrollBy = currentAnchorPosition - window.scrollY - mainNavOffset - thisNavOffset
  const scrollStep = 20
  const timeoutDelay = 800

  deactivateActiveItems()
  disableAllObservers(current.observer)

  let interval = setInterval(_ => {
     window.scrollBy(0, scrollBy / timeoutDelay * scrollStep)
  }, scrollStep)

  let timeout = setTimeout(event => {
    afterScrollToTarget(current)
    clearTimeout(timeout)
    clearInterval(interval)
  }, timeoutDelay)
}

const afterScrollToTarget = (current) => {
  enableAllObservers(current.observer)
  activateItem(current.itemToActivate)
  setLotacionHrefHash(current.target.id)
  delete current.itemToActivate.dataset.clicked
}

const enableAllObservers = except => {
  anchorLinksCollection.forEach(current => {
    if (current !== except) {
      current.observer.observe(current.target)
    }
  })
}

const disableAllObservers = except => {
  anchorLinksCollection.forEach(current => {
    if (current !== except) {
      current.observer.unobserve(current.target)
    }
  })
}

const setAnchorIntersectionObserver = current => {
  const targetHeight = current.target.getBoundingClientRect().height
  const targetHeader = current.target.querySelectorAll('h1, h2, h3')[0]
  const targetHeaderHeight = targetHeader.getBoundingClientRect().height
  const threshold = targetHeaderHeight / targetHeight * 2

  current.observer = new IntersectionObserver(entries => {
    const anchoredBlock = entries[0]

    if (anchoredBlock.isIntersecting === true) {
      onIntersecting(current)
    } else if (anchoredBlock.isIntersecting === false) {
      afterIntersecting(current)
    }
  }, { threshold: [threshold, threshold] })

  current.observer.observe(current.target)
}

const anchorLinksCollection = Array.from(nav.querySelectorAll('a[href^="#"]')).map(link => {
  const hash = new URL(link).hash
  const target = document.querySelector(hash)
  const itemToActivate = link.matches(navTogglesSelector) ? link : link.closest(navTogglesSelector)
  const current = { link, hash, target, itemToActivate }

  current.link.addEventListener('click', event => onLinkClickListener(event, current))
  setAnchorIntersectionObserver(current)

  return current
})
